// extracted by mini-css-extract-plugin
module.exports = {"styledHover":"UploadInput_styledHover__Qnf6N"};